import React from 'react';
import styled from 'styled-components';
import qs from 'qs'

const { REACT_APP_MAPS_KEY: apiKey } = process.env;

const Container = styled.iframe`
  height: 400px;
  width: 100%;
  border: 0;
`;

const Map = ({ address }) => {
  const embed = 'https://www.google.com/maps/embed/v1/place?';
  const query = {
    q: address,
    key: apiKey,
    zoom: 11,
  };

  return (
    <Container
      src={embed + qs.stringify(query)}
      allowFullScreen
    />
  );
};

export default Map;
